import qs from "qs";
import React, { useEffect, useState } from "react";
import { Button } from "../../../components/common";
import { Colours } from "../../../utils/colours";
import "swiper/css";
import "swiper/css/a11y";
import "swiper/css/navigation";
import DogCardCarousel from "../../../components/DogCardCarousel/DogCardCarousel";
import { useDogSearchApi } from "../../../context";
import "../../../theme/SwiperOverrides.css";
import WrappedSection from "../../WrappedSection/WrappedSection";
import * as styles from "./SectionBreedDogs.module.scss";

export interface SectionBreedDogsProps {
	breedNames: string[];
	title: string;
	introText: string;
	buttonText?: string;
}

export const SectionBreedDogs: React.FC<SectionBreedDogsProps> = ({
	breedNames,
	title,
	introText,
	buttonText,
}) => {
	const [items, setItems] = useState<DogsTrust.DogData[]>([]);
	const {
		results,
		resultsCount,
		onSelectBreeds,
		onResetFilters,
		useDogSearchQuery,
	} = useDogSearchApi();

	// biome-ignore lint/correctness/useExhaustiveDependencies: We only want this to run once on page load
	useEffect(() => {
		onResetFilters(true);
		onSelectBreeds(breedNames);
		useDogSearchQuery();
	}, []);

	useEffect(() => {
		setItems(results.sort((a) => (a.media?.images?.[0]?.src ? -1 : 0)));
	}, [results]);
	if (resultsCount === 0) return null;

	return (
		<WrappedSection
			sectionName="SectionBreedDogs"
			sectionColour={Colours.SUNSHINE_YELLOW}
		>
			<div className={styles.spotlightdogsinner}>
				<header className={styles.titlewrapper}>
					<h2 className={styles.title}>{title}</h2>
				</header>
				<div className={styles.introtext}>
					<p>{introText}</p>
				</div>
				<DogCardCarousel dogs={items} />
				<div className={styles.buttonwrapper}>
					<Button
						variant={"secondary"}
						ariaLabel="link to our dogs"
						fullWidth={true}
						url={`/rehoming/dogs?${qs.stringify({
							breed: breedNames,
						})}`}
					>
						{buttonText || "Show all dogs"}
					</Button>
				</div>
			</div>
		</WrappedSection>
	);
};

export default SectionBreedDogs;
